<button
  class="button alg-select-option"
  [class.selected]="selected()"
  type="button"
  (click)="select(value())"
>
  <ng-content></ng-content>
</button>
